import React from "react";
import { InPageEditableField } from "../InPageEditableField";
import { InPageHoverableField } from "../InPageHoverableField";
import { InPageEditableSectionField, TwoColumnInPageEditableSectionField } from "../types";
import SupportQuestionMark from "supportbeacon/SupportQuestionMark";
import classNames from "classnames";
import { TwoColumnInPageEditableField } from "../TwoColumnInPageEditableField";

interface NarrowProps {
  field: InPageEditableSectionField
  compact: boolean;
}

export const InPageEditableFieldSidePanelNarrow = ({ field }: NarrowProps) => {
  const hasSublabel = field.sublabel != null;

  return <div className="flex-column">
    <div className="body-text-regular s1_gray">{field.label}</div>
    {hasSublabel && <div className="s1_small s1_gray">{field.sublabel}</div>}
    <div>
      {field.inPageEdit?.hoverEdit && field.isEmpty
        ? <InPageHoverableField
          variant="sidePanel"
          compact
          field={{
            ...field,
            label: ""
          }}
        />
        : <InPageEditableField
          variant="sidePanel"
          compact
          field={{
            ...field,
            label: ""
          }}
        />
      }
    </div>
  </div>
}

interface WideProps {
  field: InPageEditableSectionField | TwoColumnInPageEditableSectionField
  compact: boolean;
}

export const InPageEditableFieldSidePanelWide = ({ compact, field }: WideProps) => {
  const hasSublabel = field.sublabel != null;
  const title = `${field.label}${hasSublabel ? `\n${field.sublabel}` : ""}`;
  const isTwoColumnField = "left" in field && "right" in field;

  return <>
    {!field.hideLabel && <div title={title} ref={field.ref} className={classNames("main-section-template-side-panel-fields-label", field.labelClassName, {
      "flex gap": field.supportArticleId,
      "sublabel": hasSublabel
    })}>
      {field.label}
      {field.supportArticleId && <SupportQuestionMark small articleId={field.supportArticleId} />}
      {hasSublabel && <div className="s1_small">{field.sublabel}</div>}
    </div>}
    {!isTwoColumnField && (
      field.inPageEdit?.hoverEdit && field.isEmpty
        ? <InPageHoverableField compact={compact} field={field} />
        : <InPageEditableField compact={compact} field={field} />
    )}
    {isTwoColumnField && <TwoColumnInPageEditableField field={field} />}
  </>
}